import { Injector, Pipe, PipeTransform } from '@angular/core';

import { TimeFormatter } from '../helper';

@Pipe({
  standalone: true,
  name: 'timeFormatter',
})
export class TimeFormatterPipe implements PipeTransform {
 constructor (private injector: Injector) {}
  transform(date: string | Date, options ?: object, ...args): string {
    return TimeFormatter(this.injector, date, options);
  }
}
